import { queryClient } from "~/plugins/vue-query";
import { settlementsService } from "~/utils/api/settlementsService";
import { getProjectId } from "~/utils/getProjectId";

export const preloadSettlements = () => {
  const projectId = getProjectId();

  if (projectId) {
    queryClient.fetchQuery({
      queryKey: ["settlements-stages"],
      queryFn: () =>
        settlementsService.getSettlementStages({
          client_project_id: projectId,
          with: ["settlements", "settlements.payments"],
          order_direction: "asc",
        }),
    });
    queryClient.fetchQuery({
      queryKey: ["settlements-invoices"],
      queryFn: () =>
        settlementsService.getSettlements({
          client_project_id: projectId,
        }),
    });
    queryClient.fetchQuery({
      queryKey: ["settlements-payments"],
      queryFn: () =>
        settlementsService.getPayments({
          client_project_id: projectId,
        }),
    });
  }
};
